import { Subject } from 'rxjs';
import { MatFormFieldControlStub } from './app.types';

/**
 * Boot-time singleton stub returned by the patched
 * `MatFormField._control` getter (see `app.config.ts`) whenever the
 * `ContentChild(MatFormFieldControl)` query is still empty. All
 * primitives read as safe defaults; callable slots are noop; and
 * `stateChanges` is a real `rxjs` `Subject<void>` so Material's own
 * `_initializeControl` can invoke both `.subscribe(...)` and
 * `.pipe(...)` on it without throwing. The stub never emits — the next
 * CD tick swaps in the real control and Material rewires its own
 * subscription pipeline against that.
 */
export const MAT_FORM_FIELD_CONTROL_STUB: MatFormFieldControlStub = {
  autofilled: false,
  controlType: null,
  describedByIds: [],
  disableAutomaticLabeling: false,
  disabled: false,
  errorState: false,
  focused: false,
  id: '',
  ngControl: null,
  onContainerClick: (): void => {},
  required: false,
  setDescribedByIds: (): void => {},
  shouldLabelFloat: false,
  stateChanges: new Subject<void>(),
  userAriaDescribedBy: null,
};

/**
 * The favicon each environment wears, keyed by the first label of its host —
 * `stag.orion.cz.foxconn.com` is `stag`.
 *
 * Keyed by host rather than by build: the pipeline builds every environment the
 * same way (`ng build --c orion-adfs`) and they are told apart only by the
 * configuration mounted into the image, so a build-time name reads
 * `orion-adfs` on staging and production alike and no icon would ever change.
 */
export const ENVIRONMENT_FAVICONS: Record<string, string> = {
  prod: 'favicon-prod.ico',
  stag: 'favicon-stag.ico',
};
